import { apiSlice } from "./apiSlice";
export const procurementBoughtItemsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllProcurementBoughtItems: builder.query({
            query: (params) => ({
                url: `ProcurementBOItem`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllProcurementBoughtItemsTracker"],
        }),
        getProcurementBoughtItemsDetail: builder.query({
            query: (req) => ({
                url: `ProcurementBOItem/${req}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        addProcurementBoughtItems: builder.mutation({
            query: (body) => ({
                url: `ProcurementBOItem`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllProcurementBoughtItemsTracker']
        }),

        editProcurementBoughtItems: builder.mutation({
            query: (body) => ({
                url: `ProcurementBOItem`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllProcurementBoughtItemsTracker']
        }),
        deleteProcurementBoughtItems: builder.mutation({
            query: (procurementBOItemId) => ({
                url: `ProcurementBOItem/${procurementBOItemId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllProcurementBoughtItemsTracker']
        }),
        getExportAllProcurementBoughtItems: builder.query({
            query: (params) => ({
                url: `ProcurementBOItem`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const {
    useLazyGetAllProcurementBoughtItemsQuery,
    useEditProcurementBoughtItemsMutation,
    useAddProcurementBoughtItemsMutation,
    useGetAllProcurementBoughtItemsQuery,
    useGetProcurementBoughtItemsDetailQuery,
    useDeleteProcurementBoughtItemsMutation,
    useLazyGetExportAllProcurementBoughtItemsQuery
} = procurementBoughtItemsSlice;
